import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import UiLoading from './Loading';
import UiIndicatorMoomoo from './indicator-moomoo';
import UiIndicatorMoomooDark from './indicator-moomoo-dark';
import UiIndicatorNiuniu from './indicator-niuniu';
export default _Object$assign(UiLoading, {
  install: app => {
    app.component(UiLoading.name, UiLoading);
    app.component(UiIndicatorMoomoo.name, UiIndicatorMoomoo);
    app.component(UiIndicatorMoomooDark.name, UiIndicatorMoomooDark);
    app.component(UiIndicatorNiuniu.name, UiIndicatorNiuniu);
  }
});
export * from './Loading';
export * from './types';